export default {"src":"/_next/static/media/safety.865c14af.svg","height":329,"width":403,"blurWidth":0,"blurHeight":0};